import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchGoogleBooks, clearGoogleBooks } from "../slice/googleBookSlice";
import GoogleBook from "./GoogleBook";
import Spinner from "../util/Spinner";
import useLoginCheck from "../util/useLoginCheck";

const BookSearch = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [query, setQuery] = useState("");
  const [hasClickedSearch, setHasClickedSearch] = useState(false);

  const { googleBooks, isLoading } = useSelector((state) => state.googleBooks);

  useLoginCheck();

  const goBack = () => navigate(-1);

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(clearGoogleBooks());
    setHasClickedSearch(true);
    dispatch(fetchGoogleBooks(query));
  };

  return (
    <div className="max-w-3xl mx-auto p-4">
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-2 mb-4">
        <input
          type="text"
          className="flex-1 border border-stone-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-600"
          placeholder="Book title or author"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          required
        />
        <div className="flex gap-2 justify-end">
          <button type="button" onClick={goBack} className="btn-secondary">
            Cancel
          </button>
          <button
            type="submit"
            disabled={query.trim() === "" || isLoading}
            className="btn-primary"
          >
            {isLoading ? "Searching..." : "Search"}
          </button>
        </div>
      </form>
      {hasClickedSearch && (
        <div>
          {isLoading ? (
            <Spinner />
          ) : (
            <div className="space-y-3">
              {googleBooks?.results?.length > 0 ? (
                googleBooks.results.map((book, index) => (
                  <GoogleBook
                    key={book.googleVolumeId ?? index}
                    googleBook={book}
                  />
                ))
              ) : (
                <div className="text-stone-500">No books found</div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default BookSearch;
